import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {SplitText} from 'gsap/SplitText.js';
gsap.registerPlugin( ScrollTrigger, SplitText );
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) return;

      const section = document.querySelector( '[data-component="scrolling-sentence"]' );
      if ( !section ) return;

      const panel1 = section.querySelector( '.scrolling-sentence__panel--1' );
      const panel2 = section.querySelector( '.scrolling-sentence__panel--2' );
      const panel3 = section.querySelector( '.scrolling-sentence__scrolling-sentence' );

      // No second or third panel — static, no scroll behavior
      if ( !panel2 && !panel3 ) return;

      // Build ordered panel list with the progress threshold at which each becomes active.
      // The last entry stays active through progress=1 (Infinity sentinel).
      let P3_START = null;
      const panelSequence = [{el: panel1, start: 0}];

      if ( panel2 && panel3 ) {
        panelSequence.push( {el: panel2, start: 0.15} );
        panelSequence.push( {el: panel3, start: 0.3} );
        P3_START = 0.3;
      } else if ( panel2 ) {
        panelSequence.push( {el: panel2, start: 0.35} );
      } else {
        panelSequence.push( {el: panel3, start: 0.4} );
        P3_START = 0.4;
      }

      // Text split only needed when panel 3 is present
      let split = null;
      let textLines = null;

      if ( panel3 ) {
        split = new SplitText( panel3.querySelector( '.ss__ss-sentence' ), {type: 'lines'} );
        split.lines.forEach( ( line ) => {
          line.innerHTML = `<span>${line.innerHTML}<span aria-hidden="true">${line.innerHTML}</span></span>`;
        } );
        textLines = panel3.querySelectorAll( '.ss__ss-sentence div > span > span' );
      }

      const endScroll = split ?
        `+=${400 + split.lines.length * 50}%` :
        '+=300%';

      let topOffset = $( '.navbar' ).outerHeight();

      if ( $( '#wpadminbar' ).length ) {
        topOffset += $( '#wpadminbar' ).outerHeight();
      }

      const mainST = ScrollTrigger.create( {
        trigger: section,
        start: 'top ' + topOffset,
        end: endScroll,
        pin: true,
        onUpdate: ( self ) => {
          const p = self.progress;
          panelSequence.forEach( ( {el, start}, i ) => {
            const nextStart = panelSequence[i + 1]?.start ?? Infinity;
            el.classList.toggle( 'is-active', p >= start && p < nextStart );
          } );
        },
      } );

      if ( panel3 && P3_START !== null && textLines?.length ) {
        gsap.timeline( {
          scrollTrigger: {
            start: () => mainST.start + P3_START * ( mainST.end - mainST.start ),
            end: () => mainST.end,
            scrub: 1,
          },
        } ).to( textLines, {
          clipPath: 'inset(0% 0% 0% 0%)',
          ease: 'power2.inOut',
          stagger: 0.4,
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'scrolling-sentence', COMPONENT );
} )( app );
